import React from 'react';
import { Filter, Refresh } from '@saleshandy/icons';
import { Button } from '@saleshandy/design-system';
import { useTranslation } from 'react-i18next';
import type { IProps } from './tasks-filter-bar-container';
import SearchInput from '../../../../../../shared/design-system/components/atoms/search-input';
import { IconPlace } from '../../../../../../shared/design-system/components/dropdown';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../../shared/design-system/components/overlay';
import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
import TasksBulkActions from '../tasks-bulk-actions';
import TaskTypeSelect from './components/task-type-select';
import { TaskStatusKey } from '../../../../utils/enums';
import Vector from '../../../../../../shared/svg/vector';

const TasksFilterBar: React.FC<IProps> = ({
  status,
  onFilterToggle,
  onSearch,
  onTaskTypeFilterApply,
  onAction,
  onRefresh,
  onStartAllTasks,
  tasksCount,
  bulkAction,
  hasSelectedTasks,
  selectedTaskCount,
  isSingleLinkedInAutomationTask,
  onClearSearch,
  searchValue,
  setSearchValue,
}) => {
  const { t } = useTranslation();

  //* Search
  const onSearchChangeHandler = (e: string) => {
    setSearchValue(e);
  };

  return (
    <div className="filter-container d-flex justify-content-between">
      <div className="d-flex align-items-center gap-20">
        <SearchInput
          onSearch={() => onSearch(searchValue)}
          searchValue={searchValue}
          setSearchValue={onSearchChangeHandler}
          onClearSearch={onClearSearch}
          placeholder="Search here..."
          searchIconPlace={IconPlace?.Left}
        />

        <OverlayTooltip
          text={t('labels.apply_filters')}
          placement={Placement.Bottom}
          className="cell-card__tooltip"
        >
          <div
            className="task-filter-icon-container"
            {...accessibleOnClick(onFilterToggle)}
          >
            <Filter width={20} height={20} className="gray-txt-15" />
          </div>
        </OverlayTooltip>

        {status !== TaskStatusKey.Completed &&
          status !== TaskStatusKey.Skipped && (
            <>
              <div className="tasks-separator" />
              <TasksBulkActions
                onAction={onAction}
                status={status}
                bulkAction={bulkAction}
                hasSelectedTasks={hasSelectedTasks}
                selectedTaskCount={selectedTaskCount}
                isSingleLinkedInAutomationTask={isSingleLinkedInAutomationTask}
              />
            </>
          )}
      </div>

      <div className="d-flex align-items-center">
        {!hasSelectedTasks && (
          <OverlayTooltip
            text={t('labels.refresh')}
            placement={Placement.Bottom}
            className="cell-card__tooltip"
          >
            <div
              className="refresh-icon-container"
              {...accessibleOnClick(onRefresh)}
            >
              <Refresh width={20} height={20} className="gray-txt-15" />
            </div>
          </OverlayTooltip>
        )}
        <div className="filter-border" />

        <div className="bs-mr-20">
          <TaskTypeSelect onApply={onTaskTypeFilterApply} />
        </div>
        {tasksCount !== 0 &&
          !(
            status === TaskStatusKey.Completed ||
            status === TaskStatusKey.Skipped
          ) && (
            <>
              <Button onClick={onStartAllTasks} className="start-tasks-btn">
                <Vector width={18} height={18} />
                <span className="ml-1">Start Tasks</span>
              </Button>
            </>
          )}
      </div>
    </div>
  );
};

export default TasksFilterBar;
